export default __webpack_public_path__ + "static/media/PopUp_lateral.4cbcc86e.jpg";